import mergeJsonSchemas from "merge-json-schemas";
import { BILLING_INFO_FORM_SCHEMA } from "./billingInformationFormSchema";
import { getSubmitTemplate } from "./schemaUtil";

const fieldsSchema = mergeJsonSchemas([
	{
		type: "object",
		required: ["cardInformation", "postalCode"],
		properties: {
			cardInformation: {
				type: "object",
				required: ["selector"],
				properties: {
					selector: { type: "string", disallowEmptyString: false }
				}
			}
		}
	},
	BILLING_INFO_FORM_SCHEMA
]);

export const CARD_FORM_SCHEMA = Object.freeze({
	type: "object",
	title: "Card Information",
	required: ["submitButton", "fields"],
	properties: {
		submitButton: { ...getSubmitTemplate() },
		fields: fieldsSchema
	}
});
